import { render, staticRenderFns } from "./DeviceIssue.vue?vue&type=template&id=48c02394"
import script from "./DeviceIssue.vue?vue&type=script&lang=js"
export * from "./DeviceIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports